import React, {useEffect, useMemo, useRef} from "react";

const VIEWER_SRC = "https://viewer.diagrams.net/js/viewer-static.min.js";


function loadViewer() {
    const id = "drawio-viewer-static";

    if (document.getElementById(id)) return;

    const s = document.createElement("script");
    s.id = id;
    s.src = VIEWER_SRC;
    s.async = true;

    document.body.appendChild(s);
}


export const DrawioReadonly = ({ xml, height = 10 }) => {
    if (xml == null) {
        xml = '<mxfile><diagram><mxGraphModel><root><mxCell id="0"/><mxCell id="1" parent="0"/>'
    }

    const divRef = useRef(null);

    // build the viewer config whenever xml changes
    const dataMxgraph = useMemo(
        () =>
            JSON.stringify({
                xml,
                nav: false,
                tooltips: false,
                border: 5,
                resize: true
            }),
        [xml]
    );

    // load viewer script once
    useEffect(() => {
        loadViewer();
    }, []);

    // (re)render the diagram whenever xml changes
    useEffect(() => {
        const el = divRef.current;
        let cancelled = false;

        if (!el) return;

        const render = () => {
            if (cancelled) return;

            el.setAttribute("data-mxgraph", dataMxgraph);
            el.innerHTML = "";

            const gv = window.GraphViewer;

            if (gv?.createViewerForElement) {
                gv.createViewerForElement(el);
            }
        };

        // wait for viewer + layout to settle
        const tryRender = () => {
            if (window.GraphViewer?.createViewerForElement) {
                // 2 rAFs helps when navigating back and the Card width updates a tick later
                requestAnimationFrame(() => requestAnimationFrame(render));
            } else {
                setTimeout(tryRender, 25);
            }
        };

        tryRender();

        // IMPORTANT: re-render when the Card/container width changes
        const ro = new ResizeObserver(() => {
            // if you resize the window or the card recalculates on back nav, re-fit
            requestAnimationFrame(render);
        });
        ro.observe(el);

        return () => {
            cancelled = true;
            ro.disconnect();
            // cleanup old render (prevents weird carry-over on fast route changes)
            if (el) el.innerHTML = "";
        };
    }, [dataMxgraph]);

    return (
        <div
            ref={divRef}
            className="mxgraph"
            style={{
                height,
                width: "100%",
                maxWidth: "100%",
                overflow: "hidden",
                minWidth: 0,
            }}
        />
    );
}